import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../features/user/auth/AuthContext';
import { API_CONFIG, apiClient } from '../../api/config';
import { logger } from '../../utils/logger';

const WatchlistContext = createContext();

export const useWatchlist = () => {
  const context = useContext(WatchlistContext);
  if (!context) {
    throw new Error('useWatchlist must be used within a WatchlistProvider');
  }
  return context;
};

export const WatchlistProvider = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const [watchlistGroups, setWatchlistGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [groupsLoaded, setGroupsLoaded] = useState(false);

  // 獲取用戶的watchlist分組列表
  const fetchWatchlistGroups = useCallback(async () => {
    if (!isAuthenticated || !user?.user_id || groupsLoaded) return;
    
    setLoading(true);
    try {
      const response = await apiClient.get(`${API_CONFIG.endpoints.watchlist.list}?user_id=${user.user_id}`);
      setWatchlistGroups(response.data);
      setGroupsLoaded(true);
      logger.log('獲取watchlist分組列表成功:', response.data);
    } catch (err) {
      logger.error('獲取watchlist分組列表失敗:', err);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, user?.user_id, groupsLoaded]);

  // 重新加載分組列表
  const refreshWatchlistGroups = useCallback(async () => {
    setGroupsLoaded(false);
    await fetchWatchlistGroups();
  }, [fetchWatchlistGroups]);

  useEffect(() => {
    if (isAuthenticated && user?.user_id && !groupsLoaded) {
      fetchWatchlistGroups();
    }
  }, [isAuthenticated, user?.user_id, groupsLoaded, fetchWatchlistGroups]);

  const value = {
    watchlistGroups,
    loading,
    groupsLoaded,
    fetchWatchlistGroups,
    refreshWatchlistGroups
  };

  return (
    <WatchlistContext.Provider value={value}>
      {children}
    </WatchlistContext.Provider>
  );
};

export default WatchlistContext;

